import type { ReactNode } from 'react';
import type { ServiceState } from 'markcat-domain';
import { SettingsIcon } from './icons';
import styles from './SidebarFooter.module.css';

interface SidebarFooterProps {
  serviceState?: ServiceState;
  onSettingsClick?: () => void;
  onStatusClick?: () => void;
  planSlot?: ReactNode;
}

const stateConfig: Record<ServiceState, { label: string; className: string; ariaLabel: string }> = {
  connected: { label: 'Connected', className: 'ok', ariaLabel: 'Service connected' },
  paused: { label: 'Paused', className: 'paused', ariaLabel: 'Worker paused' },
  unhealthy: { label: 'Backlogged', className: 'unhealthy', ariaLabel: 'Worker unhealthy or backlogged' },
  offline: { label: 'Offline', className: 'offline', ariaLabel: 'Service offline' },
  unknown: { label: 'Unknown', className: 'offline', ariaLabel: 'Service status unknown' },
};

export function SidebarFooter({ serviceState, onSettingsClick, onStatusClick, planSlot }: SidebarFooterProps) {
  const state: ServiceState = serviceState ?? 'unknown';
  const { label, className, ariaLabel } = stateConfig[state];

  return (
    <div className={styles.footer}>
      {planSlot && <div className={styles.plan}>{planSlot}</div>}
      <button
        className={styles.status}
        onClick={onStatusClick}
        aria-label={ariaLabel}
      >
        <span className={`${styles.dot} ${styles[className]}`} />
        <span className={styles.label}>{label}</span>
      </button>
      <button
        className={styles.gear}
        onClick={onSettingsClick}
        aria-label="Settings"
      >
        <SettingsIcon size={18} />
      </button>
    </div>
  );
}
